import { useEffect, useState } from "react";
export async function api(path: string, method = "GET", body?: unknown) {
  const r = await fetch(path, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = r.status === 204 ? {} : await r.json();
  if (r.status === 401 && path.startsWith("/api/owner/"))
    window.dispatchEvent(new Event("owner-session-expired"));
  if (!r.ok) throw Error(data.error || "Request failed");
  return data;
}
export function useData(path: string) {
  const [data, setData] = useState<any>(null),
    [error, setError] = useState(""),
    [revision, setRevision] = useState(0);
  useEffect(() => {
    if (path !== "/api/session") return;
    const expired = () => setRevision(n => n + 1);
    window.addEventListener("owner-session-expired", expired);
    return () => window.removeEventListener("owner-session-expired", expired);
  }, [path]);
  useEffect(() => {
    let live = true;
    setError("");
    setData(null);
    api(path)
      .then((d) => {
        if (live) setData(d);
      })
      .catch((e) => {
        if (live) setError(e.message);
      });
    return () => {
      live = false;
    };
  }, [path, revision]);
  return { data, error, reload: () => setRevision((n) => n + 1) };
}
export function date(
  value: string,
  tz = "Europe/Madrid",
  options?: Intl.DateTimeFormatOptions,
) {
  if (!value) return "Date to be announced";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: tz,
    weekday: "long",
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  }).format(new Date(value));
}
export function time(value: string, tz = "Europe/Madrid") {
  return value
    ? new Intl.DateTimeFormat("en-GB", {
        timeZone: tz,
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(value))
    : "To be scheduled";
}
export const eventURL = (slug: string) => "/events/" + slug;
